export const getNextActiveIndex = <T>(delta: number, activeIndex: number, itemsLength: number) => {
  let nextActiveIndex = activeIndex + delta;
  switch (nextActiveIndex) {
    case -1:
      nextActiveIndex = itemsLength - 1;
      break;
    case itemsLength:
      nextActiveIndex = 0;
      break;
  }
  return nextActiveIndex;
};

export const carouselNavigationKeyMapper: { [key: string]: number } = {
  ArrowRight: 1,
  ArrowLeft: -1,
};
